<div class="dg-modal-header">
    <span class="dg-modal-header__title">{{ popupTitle }}</span>
</div>
<div class="dg-modal-body">
    <div class="radio-group" *ngIf="sortingOptions">
        
        <span class="radio-group__title">Replacement reason</span>
            <ng-containter *ngFor="let options of sortingOptions">
                <ng-container *ngIf="options.reasonType==sortingColumnNames.BadgeRequestReasonName">
                    <ng-container *ngTemplateOutlet="radioBtnTemplate; 
                    context: {
                        index: options, 
                        value: selectedSortingColumn, 
                        sortNames: sortingColumnNames, 
                        sortOrder: sortOrder
                    }">
                    </ng-container>
                </ng-container>
            </ng-containter>

        <span class="radio-group__title">Date (UTC)</span>
            <ng-containter *ngFor="let options of sortingOptions">
                <ng-container *ngIf="options.reasonType==sortingColumnNames.RequestedDateStr">
                    <ng-container *ngTemplateOutlet="radioBtnTemplate; 
                    context: {
                        index: options, 
                        value: selectedSortingColumn, 
                        sortNames: sortingColumnNames, 
                        sortOrder: sortOrder
                    }">
                    </ng-container>
                </ng-container>
            </ng-containter>

        <span class="radio-group__title">Photo status</span>
            <ng-containter *ngFor="let options of sortingOptions">
                <ng-container *ngIf="options.reasonType==sortingColumnNames.PhotoRequestStatusName">
                    <ng-container *ngTemplateOutlet="radioBtnTemplate; 
                    context: {
                        index: options, 
                        value: selectedSortingColumn, 
                        sortNames: sortingColumnNames, 
                        sortOrder: sortOrder
                    }">
                    </ng-container>
                </ng-container>
            </ng-containter>

        <span class="radio-group__title">Badge status</span>
            <ng-containter *ngFor="let options of sortingOptions">
                <ng-container *ngIf="options.reasonType==sortingColumnNames.BadgeRequestStatusName">
                    <ng-container *ngTemplateOutlet="radioBtnTemplate; 
                    context: {
                        index: options, 
                        value: selectedSortingColumn, 
                        sortNames: sortingColumnNames, 
                        sortOrder: sortOrder
                    }">
                    </ng-container>
                </ng-container>
            </ng-containter>
    </div>

    <ng-template #radioBtnTemplate let-index="index" let-selectedValue="value" let-sortNames="sortNames" let-sortOrder="sortOrder">
        <label class="rb-label">
            <input type="radio"
                name="index"
                [checked]="index.sortName===selectedValue"
                [value]="index.sortName"
                (change)="toggleColumnSort(index.sortName)">
            <span></span>
            <ng-container *ngIf="index.reasonType==sortNames.RequestedDateStr; else alphabeticalOrder">
                <ng-container *ngIf="index.sortingOrder===sortOrder.ASC; else descBlock">
                    Sort 1–9
                </ng-container>
                <ng-template #descBlock>
                    Sort 9–1
                </ng-template>
            </ng-container>
            <ng-template #alphabeticalOrder>
                <ng-container *ngIf="index.sortingOrder===sortOrder.ASC; else descBlock">
                    Sort A–Z
                </ng-container>
                <ng-template #descBlock>
                    Sort Z–A
                </ng-template>
            </ng-template>
        </label>
    </ng-template>
</div>

<div class="dg-modal-footer">
    <button
        *ngIf="showButtonNo"
        appTrackClickButton
        id="dismiss"
        type="button"
        class="button secondary"
        (click)="action(false)"
    >
        {{ buttonsTitle.dismiss }}
    </button>
    <button
        *ngIf="showButtonYes"
        appTrackClickButton
        id="confirm"
        type="button"
        class="button primary"
        (click)="applySorting()"
    >
        {{ buttonsTitle.confirm }}
    </button>
</div>

